import i18n from 'i18n';
import { FormLabel } from '../form-label';
import LOCALS from 'commons/locals';
import { Control, Controller } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { Select } from 'antd';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { useAppSelector } from 'store/hooks';

const ProductExtendType = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  const { typeSelectOptions } = useAppSelector(selectGlobalInfo);

  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.product_type)}:</FormLabel>
      <Controller
        name="extendType"
        control={control}
        render={({ field }) => (
          <Select
            className="w-full"
            {...field}
            options={typeSelectOptions}
            placeholder={i18n.t(LOCALS.please_select)}
            onChange={(value) => field.onChange(value)}
            allowClear
          />
        )}
      />
    </div>
  );
};

export default ProductExtendType;
